import { OrderItemRecipient } from "../models/Order";
import { SendTicketsRequest } from "../pages/store/[cartUrl]/thank-you/[retrievalKey]";
import axios from "./axios";
import { BuildUri } from "./BuildUri";

class TicketRetrievalEndpoints {
    static async sendTickets(
        retrievalKey: string,
        request: SendTicketsRequest,
    ) {
        return (
            await axios.post<OrderItemRecipient[]>(
                BuildUri("/ticket/send-order-tickets/{retrievalKey}", {
                    retrievalKey,
                }),
                request,
            )
        ).data;
    }

    static async getTicketBase64(retrievalKey: string, orderItemId: number) {
        return (
            await axios.get<string>(
                BuildUri("/ticket/{retrievalKey}/{orderItemId}/base64", {
                    orderItemId,
                    retrievalKey,
                }),
            )
        ).data;
    }

    static async getTicketPkPass(retrievalKey: string, orderItemId: number) {
        return (
            await axios.get<string>(
                BuildUri("/ticket/{retrievalKey}/{orderItemId}/pkpass", {
                    orderItemId,
                    retrievalKey,
                }),
            )
        ).data;
    }

    static getTicketPkPassUrl(retrievalKey: string, orderItemId: number) {
        return BuildUri("/ticket/{retrievalKey}/{orderItemId}/pkpass", {
            orderItemId,
            retrievalKey,
        });
    }

    static async sendOrderLinks(request: any, cartUrl: string) {
        return (
            await axios.post<any>(
                BuildUri("/ticket/send-order-links", {}, { cartUrl }),
                request,
            )
        ).data;
    }

    static async resendOrderEmail(retrievalKey: string, request: any) {
        return (
            await axios.post<void>(
                BuildUri("/sales/email-order/{retrievalKey}", {
                    retrievalKey,
                }),
                request,
            )
        ).data;
    }
}

export default TicketRetrievalEndpoints;
